import React from "react";
import { useParams } from "react-router-dom";
import { Card, Col, Row, Table,} from "antd";
import { useGetUserQuery } from "../api/api";
import Spinner from "../components/Spinner";
import { Error } from "../components/Error.component";
import type { SortOrder } from "antd/es/table/interface"; // Import SortOrder


export const UserDetails = (props) => {
  const routeParams = useParams();
  const { data, error, isLoading } = useGetUserQuery(routeParams.userId);



  let productsCost = 0;
  let productsCount = 0;
  let apps = [];

  if (data) {
    productsCost = data.productsPrice;
    productsCount = data.productsCount;
    apps = data.apps;
    console.log("User:", data);
  }

  console.log(apps);
  const columns = [
    {
      title: "Name",
      dataIndex: "licensename_0",
      key: "licensename_0",
      className: "table-cell-padding",
    },
    {
      title: "Publisher",
      dataIndex: "publishername_0",
      key: "publishername_0",
      className: "table-cell-padding",
    },
    {
      title: "License cost (Year)",
      dataIndex: "costpermonth_0",
      key: "costpermonth_0",
      render: (value) => (
        <div style={{ textAlign: 'right' }}>
          {`$${Math.round(parseFloat(value) * 12).toLocaleString()}`}
        </div>
      ),
      sorter: (a, b) => (a.costpermonth_0 * 12) - (b.costpermonth_0 * 12), // Sort by annual cost
      defaultSortOrder: 'descend' as SortOrder, // Use SortOrder type
      className: "table-cell-padding"
    },
  ];

  return (
    <div className="montserrat-font">
      {isLoading && <Spinner />}
      {error && <Error error={"Oops"} />}
      {data && !error && (
        <div>
          <Row gutter={32} >
            <Col xs={24} sm={12}>
              <Card title="Employee Details" className="muse-card" style={{ width: "100%" }} >
                <h3>Name:  <strong>{data?.employeename_0}</strong></h3>
                <h3>Business Unit:  <strong>{data?.businessunit_0}</strong></h3>
                <h3>Department:  <strong>{data?.departmentcode_0}</strong></h3>
              </Card>
            </Col>
            <Col xs={24} sm={12}>
              <Card title="License overview" className="muse-card" style={{ width: "100%" }}>
                <h3>Total number of licenses assigned:  <strong>{productsCount}</strong></h3>
                <h3>Total assigned license cost: <strong>${Math.round(productsCost).toLocaleString()} / Month</strong></h3>
<h3>Total assigned license cost: <strong>${Math.round(productsCost * 12).toLocaleString()} / Year</strong></h3>

              </Card>
            </Col>
          </Row>
          <Row>
            <Card className="muse-card" style={{ width: "100%" }}>
              <Table
                columns={columns}
                dataSource={apps}
                className="montserrat-font"
                rowClassName={() => "table-row-spacing"}
              />
            </Card>
          </Row>
        </div>
      )}
    </div>
  );
};
